import {
  FETCH_MANAGER_BRANCH_MISSION_REQUEST,
  FETCH_MANAGER_BRANCH_MISSION_SUCCESS,
  FETCH_MANAGER_BRANCH_MISSION_ERROR,
  UPDATE_MANAGER_BRANCH_MISSION_REQUEST,
  UPDATE_MANAGER_BRANCH_MISSION_SUCCESS,
  UPDATE_MANAGER_BRANCH_MISSION_ERROR,
  RESET_MENU_MISSIONS,
  RESET_EDIT_MENU_MISSION,
  GET_MENU_MISSION_FROM_LIST,
  REMOVE_MENU_MISSION_SUCCESS,
  REMOVE_MENU_MISSION_ERROR,
  CLEAR_SUCCESS_MESSAGE,
  FETCH_MISSIONS_OPTIONS_REQUEST,
  FETCH_MISSIONS_OPTIONS_SUCCESS,
  FETCH_MISSIONS_OPTIONS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
    options: [],
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    removed: false,
  },
  success: '',
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_MANAGER_BRANCH_MISSION_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_MANAGER_BRANCH_MISSION_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_MANAGER_BRANCH_MISSION_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: action.payload,
        },
      }

    case UPDATE_MANAGER_BRANCH_MISSION_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }

    case UPDATE_MANAGER_BRANCH_MISSION_SUCCESS:
      return {
        ...state,
        success: null,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: null,
          record: action.payload,
          updated: true,
          removed: false,
        },
      }

    case UPDATE_MANAGER_BRANCH_MISSION_ERROR:
      return {
        ...state,
        success: '',
        edit: {
          ...state.edit,
          isUpdating: false,
          error: action.payload,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case RESET_MENU_MISSIONS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: null,
        },
      }

    case RESET_EDIT_MENU_MISSION:
      return {
        ...state,
        edit: {
          isUpdating: false,
          error: null,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case GET_MENU_MISSION_FROM_LIST:
      const { index } = action
      const record = state.list.records[index]

      return {
        ...state,
        get: {
          ...state.get,
          record,
          error: null,
          isFetching: false,
        },
      }

    case REMOVE_MENU_MISSION_SUCCESS:
      return {
        ...state,
        success: null,
        edit: {
          ...state.edit,
          error: null,
          updated: false,
          removed: true,
        },
      }

    case REMOVE_MENU_MISSION_ERROR:
      return {
        ...state,
        success: '',
        edit: {
          ...state.edit,
          error: action.payload,
          updated: false,
          removed: false,
        },
      }

    case CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        success: '',
      }

    case FETCH_MISSIONS_OPTIONS_REQUEST:
      return {
        ...state,
      }

    case FETCH_MISSIONS_OPTIONS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          options: action.payload,
        },
      }

    case FETCH_MISSIONS_OPTIONS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          options: '',
        },
      }

    default:
      return state
  }
}

export default record
